module.exports = __webpack_public_path__ + "img/logo-colored.d68686ae.png";